import { useNavigate } from 'react-router';
import * as Yup from 'yup';
import { Box, Button, Card, CardContent, Grid, Container } from '@mui/material';
import { Form, Formik, FormikProps } from 'formik';

// Hooks and services
import { useNotifyMessage } from '../../../hooks/useNotifyMessage';
import { anonymousPasswordResetRequest } from '../../../services/user.service';

// Components
import SiteBranding from '../../base/branding/sitebranding';
import TextField from '../../common/forms/TextField';
import Footer from '../../base/layout/Footer';

export default function AppUserPasswordResetAnonymous() {
  const { notifyMessage } = useNotifyMessage();
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    // 1. Send to api
    const response = await anonymousPasswordResetRequest(values.email);

    if (response.status == 200) {
      // 2. Go to sent confirmation page
      navigate('/password-reset-sent', { state: { email: values.email } });

      return;
    }

    if (response.status > 400) {
      // Something wrong
      notifyMessage('Unexpected error', 'error');
    }
  };

  interface PasswordResetRequest {
    email: string;
  }

  const validationSchema = Yup.object<PasswordResetRequest>({
    email: Yup.string().required('Email address is required').email('Email is not a valid email address'),
  });

  const initialValues = {
    email: '',
  };

  let formRef: FormikProps<PasswordResetRequest>;
  const buttonLabel = 'Reset my password';

  return (
    <>
      <div className='app'>
        <main className='content'>
          <div className='content_body'>
            <Container maxWidth={'md'}>
              <Box display='flex' justifyContent='center' className='logoBox'>
                <Box display='flex'>
                  <SiteBranding className='logo' />
                </Box>
              </Box>
              <Box display='flex' justifyContent='center' className='logoBox'>
                <Box display='flex'>
                  <h1>Password reset</h1>
                </Box>
              </Box>
              <Box display='flex' justifyContent='center' className='logoBox'>
                <Box>
                  <p>Enter the email address that you registered with and hit &quot;{buttonLabel}&quot;</p>
                </Box>
              </Box>
              <Box>
                <Card>
                  <CardContent>
                    <Formik initialValues={{ ...initialValues }} onSubmit={handleSubmit} validationSchema={validationSchema}>
                      {(props: FormikProps<PasswordResetRequest>) => (
                        <Form>
                          {props ? (formRef = props) && '' : ''}
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <TextField label={'Email address'} type='email' required={true} name='email' />
                            </Grid>

                            <Grid item xs={12}>
                              <Button type='submit' color='primary' variant='contained'>
                                {buttonLabel}
                              </Button>
                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </CardContent>
                </Card>
              </Box>
              <Footer />
            </Container>
          </div>
        </main>
      </div>
    </>
  );
}
